import React, { Component } from 'react';
import Popover from 'housecall-ui/dist/DesignSystem/DataDisplay/Popover/Popover';
import MenuList from 'housecall-ui/dist/DesignSystem/Navigation/Menus/MenuList';
import FranchiseeList from './FranchiseeList.jsx';
import FranchiseMenuIcon from './FranchiseMenuIcon.jsx';

export default class FranchiseMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopoverOpen: false,
      menuAnchor: null,
    };
  }

  handleNavMenuClick(event) {
    this.setState({
      isPopoverOpen: true,
      menuAnchor: event.currentTarget,
    });
  }

  handleNavMenuRequestClose() {
    this.setState({ isPopoverOpen: false });
  }

  render() {
    return (
      <>
        <FranchiseMenuIcon
          {...this.props}
          handleNavMenuClick={this.handleNavMenuClick.bind(this)}
          franchisee={this.props.franchisees[0]}
        />
        <Popover
          open={this.state.isPopoverOpen}
          anchorEl={this.state.menuAnchor}
          anchorReference="anchorEl"
          onClose={() => {
            this.handleNavMenuRequestClose();
          }}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        >
          <MenuList>
            <FranchiseeList franchisees={this.props.franchisees} />
          </MenuList>
        </Popover>
      </>
    );
  }
}
